/** Used as an action type when starting the notification saga */
export const NOTIFICATION = 'NOTIFICATION'

/** Used as an action type when adding a notification */
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'

/** Used as an action type when clearing a notification */
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'



// WEBPACK FOOTER //
// ./src/actions/notificationActionTypes.js